import { Link } from '@mercadoni/sinister/dist/lib/src/entities/clientModel'
export interface IProps {
  link?: Link
}

const getPagesWithCanonicals = ({ link }: IProps) => {
  const { canonical } = link || {}
  const hasCanonical = canonical?.length ?? 0
  return hasCanonical > 0 ? canonical : undefined
}

export { getPagesWithCanonicals }
